import moment from 'moment';

export const apiEndPoint = {
  application: {
    application: '/application',
  },
  user: {
    userInfo: '/users/user-info',
    signup: '/users/signup',
    registration: '/users/registration',
    updateUsername: '/users/update-username',
    forgotPassword: '/users/passphrase/forgot',
    verificationCode: '/users/passphrase/check-verification-code',
    resetPassword: '/users/passphrase/reset',
    userList: '/users/search-username',
    roleList: '/users/role-list',
    manageRole: '/users/manage-role',
    getBalance: '/users/get-balance',
    emailExist: '/users/check-email-exist',
    usernameExist: '/users/check-username-exist',
    allPlayer: '/feedback/all-player',
    logOutDetail: '/users/logout',
  },
  authentication: {
    login: '/authentication/login',
    socialLogin: '/authentication/login-with-social',
  },
  platformLink: {
    types: '/platform-link/types',
  },
  newsletter: {
    postNewsletter: '/newsletter',
  },
  emailVerification: {
    verifyEmail: '​/email-verify​',
    resendVerificationMail: '/email-verify/resend-email-verification',
  },
  cashIn: {
    rapydMethods: '/cash-in/rapyd/methods',
    rapydFee: '/cash-in/rapyd/fee',
    rapyd: '/cash-in/rapyd',
    rapydCallback: '/cash-in/rapyd/call-back',
  },
  games: {
    list: '/game/list',
    all: '/games',
    gameImage: '/game/games-image',
    matchList: '/game/get-match-list',
    tournamentList: '/game/get-tournament-list',
    addGameDeveloper: '/game-developer/add-game-developer',
    updateGameDeveloper: '/game-developer/update-game-developer',
    listGameDeveloper: '/game-developer/list-game-developer',
    detailGameDeveloper: '/game-developer/game-developer-detail',
  },
  match: {
    create: '/match/create',
    acceptInvite: '/match/accept-invite',
    declineInvite: '/match/decline-invite',
    join: '/match/join',
    acceptJoin: '/match/accept-join',
    rejectJoin: '/match/reject-join',
    forfeit: '/match/forfeit',
    withdraw: '/match/withdraw',
    getPercent: '/match/get-match-percent',
    openMatch: '/match/get-open-match-list',
    pendingMatch: '/match/get-pending-match-list',
    matchHistory: '/match/get-match-history-list',
    matchDetails: '/match/get-match-details',
    play: '/match/challenge/play',
    matchHistoryDetail: '/match/match-history-detail',
    matchUsername: '/match/search-username',
    activeTournament: '/match/my-active-tournament-list',
  },
  tournament: {
    createTournament: '/tournament/create',
    cancelTournament: '/tournament/cancel', //'/games/cancel-tournament'
    list: '/tournament/my-tournament-list',
    details: '/tournament/tournament-details',
    tournamentCalculationEarning: '/tournament/tournament-calculation-earning',
    tournamentCalculationPrizeDistribution:
      '/tournament/tournament-calculation-prizes-distribution',
    play: '/tournament/play-game',
    historyTournament: '/tournament/my-tournament-history-list',
    historyDetails: '/tournament/tournament-history-details',
  },
  admin: {
    searchUser: '/admin/search-user',
    manageRole: '/admin/manage-role',
    banUser: '/admin/ban-user',
    removeBanUser: '/admin/remove-ban-user',
    deleteUser: '/admin/delete-user',
    addFund: '/admin/add-fund',
    userDetail: '/admin/user-detail',
    tournamentList: '/admin/Tournament-List',
    updateRole: '/admin/update-role',
    createTournament: '/admin/create/tournament',
  },
  notification: {
    notificationList: '/notification/list',
    notificationDetail: '/notification',
    notificationRead: '/notification/notification-read',
  },
  dashboard: {
    dashboardDetail: '/dashboard',
    getNavCount: '/dashboard/match-count',
  },
  transaction: {
    list: '/cash-in/transaction-history',
  },
};
export const tileSliderSetting = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  centerPadding: '50px',
  responsive: [
    {
      breakpoint: 1499,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
      },
    },
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: false,
      },
    },
  ],
};

export const hostPercentageOptions = [
  { value: 0, label: '0%' },
  { value: 5, label: '5%' },
  { value: 10, label: '10%' },
  { value: 15, label: '15%' },
  { value: 20, label: '20%' },
  { value: 25, label: '25%' },
  { value: 30, label: '30%' },
  { value: 35, label: '35%' },
  { value: 40, label: '40%' },
  { value: 45, label: '45%' },
  { value: 50, label: '50%' },
  { value: 55, label: '55%' },
  { value: 60, label: '60%' },
];

export const thresholdPercentage = [
  { value: 0, label: '0%' },
  { value: 5, label: '5%' },
  { value: 10, label: '10%' },
  { value: 15, label: '15%' },
  { value: 20, label: '20%' },
  { value: 25, label: '25%' },
  { value: 30, label: '30%' },
  { value: 35, label: '35%' },
  { value: 40, label: '40%' },
  { value: 45, label: '45%' },
  { value: 50, label: '50%' },
  { value: 55, label: '55%' },
  { value: 60, label: '60%' },
  { value: 65, label: '65%' },
  { value: 70, label: '70%' },
  { value: 75, label: '75%' },
  { value: 80, label: '80%' },
  { value: 85, label: '85%' },
  { value: 90, label: '90%' },
  { value: 95, label: '95%' },
  { value: 100, label: '100%' },
];

export const percentageOptions = [
  { value: 0, label: '0%' },
  { value: 5, label: '5%' },
  { value: 10, label: '10%' },
  { value: 15, label: '15%' },
  { value: 20, label: '20%' },
  { value: 25, label: '25%' },
  { value: 30, label: '30%' },
  { value: 35, label: '35%' },
  { value: 40, label: '40%' },
  { value: 45, label: '45%' },
  { value: 50, label: '50%' },
  { value: 55, label: '55%' },
  { value: 60, label: '60%' },
  { value: 65, label: '65%' },
  { value: 70, label: '70%' },
  { value: 75, label: '75%' },
  { value: 80, label: '80%' },
  { value: 85, label: '85%' },
  { value: 90, label: '90%' },
  { value: 95, label: '95%' },
  { value: 100, label: '100%' },
];

export const options = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
];

export const rankOptions = [
  { value: 'rank-position', label: 'Rank Position' },
  { value: 'top-percent', label: 'Top Position' },
];

export const distributionOptions = [
  { value: 'tiered', label: 'Automatic Tiers' },
  { value: 'equal', label: 'Equal Division' },
  { value: 'weighted', label: 'Manual Weighted' },
];

export const eliminationOptions = [
  { value: 'async-tournament', label: 'Async Tournament' },
  {
    value: 'single-elimination-tournament',
    label: 'Single Elimination Tournament',
  },
  {
    value: 'double-elimination-tournament',
    label: 'Double Elimination Tournament',
  },
];

export const durationOptions = [
  { value: 24, label: '1d' },
  { value: 48, label: '2d' },
  { value: 72, label: '3d' },
  { value: 96, label: '4d' },
  { value: 120, label: '5d' },
  { value: 144, label: '6d' },
  { value: 168, label: '7d' },
];

export const rankedOptions = [
  { value: 0, label: 'Unlimited' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
];

export const statusOption = [
  { value: 'enabled', label: 'enabled' },
  { value: 'disabled', label: 'disabled' },
];

export const typeOption = [
  { value: 'synchronous', label: 'synchronous' },
  { value: 'asynchronous', label: 'asynchronous' },
];

export const bestOfOption = [
  { value: 1, label: '1' },
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 7, label: '7' },
];

export const breakOption = [
  { value: 0, label: '0 minutes' },
  { value: 1, label: '1 minutes' },
  { value: 2, label: '2 minutes' },
  { value: 3, label: '3 minutes' },
  { value: 4, label: '4 minutes' },
  { value: 5, label: '5 minutes' },
  { value: 6, label: '6 minutes' },
  { value: 7, label: '7 minutes' },
  { value: 8, label: '8 minutes' },
  { value: 9, label: '9 minutes' },
  { value: 10, label: '10 minutes' },
];

export const timeGmtOptions = [
  { parse: '-12:00', value: -720, label: 'GMT-12' },
  { parse: '-11:00', value: -660, label: 'GMT-11' },
  { parse: '-10:00', value: -600, label: 'GMT-10' },
  { parse: '-09:00', value: -540, label: 'GMT-9' },
  { parse: '-08:00', value: -480, label: 'GMT-8' },
  { parse: '-07:00', value: -420, label: 'GMT-7' },
  { parse: '-06:00', value: -360, label: 'GMT-6' },
  { parse: '-05:00', value: -300, label: 'GMT-5' },
  { parse: '-04:00', value: -240, label: 'GMT-4' },
  { parse: '-03:00', value: -180, label: 'GMT-3' },
  { parse: '-02:00', value: -120, label: 'GMT-2' },
  { parse: '-01:00', value: -60, label: 'GMT-1' },
  { parse: '+00:00', value: 0, label: 'GMT' },
  { parse: '+01:00', value: 60, label: 'GMT+1' },
  { parse: '+02:00', value: 120, label: 'GMT+2' },
  { parse: '+03:00', value: 180, label: 'GMT+3' },
  { parse: '+04:00', value: 240, label: 'GMT+4' },
  { parse: '+05:00', value: 300, label: 'GMT+5 (GMT+5:30)' },
  // { parse: '+05:30', value: 330, label: 'GMT+5:30' },
  { parse: '+06:00', value: 360, label: 'GMT+6' },
  { parse: '+07:00', value: 420, label: 'GMT+7' },
  { parse: '+08:00', value: 480, label: 'GMT+8' },
  { parse: '+09:00', value: 540, label: 'GMT+9' },
  { parse: '+10:00', value: 600, label: 'GMT+10' },
  { parse: '+11:00', value: 660, label: 'GMT+11' },
];

export const getDefaultTimeZoneOffset = () => {
  let offset = moment.parseZone(moment()).utcOffset();

  if (offset === 330) {
    offset = 300;
  }

  const selected = timeGmtOptions.find((d) => d.value === offset);
  const defaultTZ = timeGmtOptions.find((d) => d.value === 300);

  return selected ?? defaultTZ;
};

export const getTimeZoneLabelByParse = (value) => {
  const selected = timeGmtOptions.find((d) => d.parse === value);
  return selected?.label ?? null;
};
